<template>
  <div class="d-flex">
    <Sidebar />

    <div class="content p-4">
      <h2 class="mb-4">📊 Panel de Control</h2>

      <!-- Tarjetas KPI -->
      <div class="row mb-4">
        <div class="col-md-4 mb-3" v-for="card in kpis" :key="card.label">
          <div class="card shadow-sm p-3 bg-white rounded h-100">
            <h6 class="text-muted">{{ card.label }}</h6>
            <h4 class="text-primary">{{ card.value }}</h4>
          </div>
        </div>
      </div>

      <!-- Gráfica de Línea -->
      <div class="row mb-4">
        <div class="col-md-12">
          <div class="card p-3 shadow-sm bg-white rounded">
            <h6 class="mb-3">Vistas por Día</h6>
            <canvas id="vistasChart" height="100"></canvas>
          </div>
        </div>
      </div>

      <!-- Gráfica de Barras y Dona -->
      <div class="row">
        <div class="col-md-6 mb-4">
          <div class="card p-3 shadow-sm bg-white rounded h-100">
            <h6 class="mb-3">Tipos de Seguro Más Vendidos</h6>
            <canvas id="segurosChart" height="200"></canvas>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="card p-3 shadow-sm bg-white rounded h-100">
            <h6 class="mb-3">Seguimiento de Prospectos</h6>
            <canvas id="contactosChart" height="200"></canvas>
          </div>
        </div>
      </div>

      <!-- Gauge Total de Vistas -->
      <div class="row mt-4">
        <div class="col-md-4 mx-auto">
          <div class="card p-3 shadow-sm bg-white rounded h-100 text-center">
            <h6 class="mb-3">Total de Vistas</h6>
            <canvas id="gaugeChart" width="200" height="200"></canvas>
            <div class="mt-2 h5 text-primary">{{ totalVistas }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Sidebar from './Sidebar.vue';
import Chart from 'chart.js';
import 'chartjs-gauge';

export default {
  components: { Sidebar },
  data() {
    return {
      totalVistas: 0,
      promedioEstadia: 0,
      kpis: [
        { label: 'Promedio de Estancia (seg)', value: 0 },
        { label: 'Prospectos Contactados', value: 120 },
        { label: 'Citas Agendadas', value: 65 },
        { label: 'Personas que abandonaron el sitio', value: 37 },
        { label: 'Citas Pendientes', value: 18 },
        { label: 'Clientes Actuales', value: 42 },
        { label: 'Visualizaciones del Blog', value: 310 },
        { label: 'Seguro más vendido', value: 'Seguro de Vida' }
      ]
    };
  },
  mounted() {
    this.fetchVistasEstadisticas();
    this.renderContactosChart();
    this.renderSegurosChart();
  },
  methods: {
    fetchVistasEstadisticas() {
      axios.get('http://localhost:3000/api/visitas/estadisticas')
        .then(res => {
          this.totalVistas = res.data.total_vistas || 0;
          this.promedioEstadia = res.data.promedio_estadia || 0;

          // Actualizamos KPI de promedio
          this.kpis[0].value = this.promedioEstadia;

          // Renderizamos gráficas
          this.renderGaugeChart(this.totalVistas);
          this.renderVistasChart(res.data.vistas_por_dia || []);
        })
        .catch(err => {
          console.error("Error al obtener datos del dashboard:", err);
        });
    },

    renderGaugeChart(valor) {
      const maxValor = 500; // ajusta este máximo según lo esperado

      new Chart(document.getElementById('gaugeChart'), {
        type: 'gauge',
        data: {
          datasets: [{
            value: valor,
            minValue: 0,
            data: [maxValor],
            backgroundColor: ['#3f51b5'],
            borderWidth: 2
          }]
        },
        options: {
          responsive: true,
          needle: {
            radiusPercentage: 2,
            widthPercentage: 3.2,
            lengthPercentage: 80,
            color: '#3f51b5'
          },
          valueLabel: {
            display: false
          }
        }
      });
    },

    renderContactosChart() {
      new Chart(document.getElementById('contactosChart'), {
        type: 'doughnut',
        data: {
          labels: ['Contactados', 'Citas', 'Abandonos'],
          datasets: [{
            data: [120, 65, 37],
            backgroundColor: ['#4CAF50', '#2196F3', '#FF5722']
          }]
        },
        options: {
          responsive: true,
          legend: { position: 'bottom' },
        }
      });
    },

    renderSegurosChart() {
      new Chart(document.getElementById('segurosChart'), {
        type: 'bar',
        data: {
          labels: ['Vida', 'Gastos Médicos', 'Educativo', 'Ahorro', 'Viajes'],
          datasets: [{
            label: 'Seguros Vendidos',
            data: [25, 18, 12, 8, 6],
            backgroundColor: '#3F51B5'
          }]
        },
        options: {
          responsive: true,
          legend: { display: false },
        }
      });
    },

    renderVistasChart(data) {
      const dias = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
      if (!data.length) data = [30, 45, 55, 60, 70, 90, 110];

      new Chart(document.getElementById('vistasChart'), {
        type: 'line',
        data: {
          labels: dias,
          datasets: [{
            data,
            backgroundColor: 'rgba(33, 150, 243, 0.2)',
            borderColor: '#2196F3',
            borderWidth: 2,
            fill: true
          }]
        },
        options: {
          responsive: true,
          legend: { display: false }
        }
      });
    }
  }
}
</script>

<style scoped>
.d-flex {
  min-height: 100vh;
}

.content {
  flex-grow: 1;
  margin-left: 250px;
  background-color: #f5f5f5;
}

.card {
  border-left: 4px solid #007bff;
  background-color: #fff;
}
</style>
